import { render, staticRenderFns } from "./PageStocks.vue?vue&type=template&id=c7f35312&"
import script from "./PageStocks.vue?vue&type=script&lang=js&"
export * from "./PageStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports